import Button from "components/base/Button";
import { Input } from "components/base/Form";

const PricesForm = ({ prices, onChange }) => {
  return (
    <table>
      <tbody>
        {prices.map((i, index) => (
          <tr key={index} className="border-y">
            <td>
              <div className="flex space-x-3 items-center">
                <Button
                  trash
                  onClick={() => {
                    onChange(prices.filter((_, idx) => idx !== index));
                  }}
                />
                <label>For quantity+:</label>
                <Input
                  className="text-right"
                  value={i.qty}
                  onChange={(e) => {
                    onChange(
                      prices.map((p, idx) =>
                        idx === index ? { ...p, qty: e.target.value } : p,
                      ),
                    );
                  }}
                />
              </div>
            </td>
            <td>
              <div className="flex justify-end items-center space-x-3">
                <label>Cost:</label>
                <Input
                  className="text-right"
                  value={i.price}
                  onChange={(e) => {
                    onChange(
                      prices.map((p, idx) =>
                        idx === index ? { ...p, price: e.target.value } : p,
                      ),
                    );
                  }}
                />
              </div>
            </td>
          </tr>
        ))}

        <tr>
          <td>
            <Button
              onClick={() => {
                onChange([...prices, { quantity: "", cost: "" }]);
              }}
            >
              + Add Price
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default PricesForm;
